import { Col, Row, Select, Table } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import "./BudgetReportCR.css";
import {
  GetViewAutoBudgetMonthly,
  GetYearBudget,
} from "../../Services/BudgetReportService";
import { Button } from "primereact/button";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

function BudgetByMonthFiscalYear() {
  const [loading, setLoading] = useState(false);
  const [pageSize] = useState<number>(10);

  // Table Data
  const [incomeData, setIncomeData] = useState<any[]>([]);
  const [expenseData, setExpenseData] = useState<any[]>([]);

  // Table Columns
  const [incomeColumns, setIncomeColumns] = useState<any[]>([]);
  const [expenseColumns, setExpenseColumns] = useState<any[]>([]);

  // rawRow เก็บ data rows ทั้งหมด จาก API
  const [rawRow, setRawRow] = useState<any[]>([]);

  // Filter
  const [selectedYear, setSelectedYear] = useState<string>(
    (new Date().getFullYear() + 543).toString(),
  );
  const [selectedMonths, setSelectedMonths] = useState<string[]>([]);
  const [selectedDivision, setSelectedDivision] = useState<string[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState<string[]>([]);

  // Dropdown options
  const [yearOption, setYearOption] = useState<any[]>([]);
  const monthOption = [
    { label: "มกราคม (JAN)", value: "JAN" },
    { label: "กุมภาพันธ์ (FEB)", value: "FEB" },
    { label: "มีนาคม (MAR)", value: "MAR" },
    { label: "เมษายน (APR)", value: "APR" },
    { label: "พฤษภาคม (MAY)", value: "MAY" },
    { label: "มิถุนายน (JUN)", value: "JUN" },
    { label: "กรกฎาคม (JUL)", value: "JUL" },
    { label: "สิงหาคม (AUG)", value: "AUG" },
    { label: "กันยายน (SEP)", value: "SEP" },
    { label: "ตุลาคม (OCT)", value: "OCT" },
    { label: "พฤศจิกายน (NOV)", value: "NOV" },
    { label: "ธันวาคม (DEC)", value: "DEC" },
  ];
  const [divisionOption, setDivisionOption] = useState<any[]>([]);
  const [departmentOption, setDepartmentOption] = useState<any[]>([]);

  // เก็บ data ที่ Filter
  const [filterIncomeData, setFilterIncomeData] = useState<any[] | null>(null);
  const [filterExpenseData, setFilterExpenseData] = useState<any[] | null>(
    null,
  );

  // key data sync
  const [incomeTableKeys, setIncomeTableKeys] = useState<string[]>([]);
  const [expenseTableKeys, setExpenseTableKeys] = useState<string[]>([]);

  useEffect(() => {
    fetchData();
  }, []);

  // fetchData GetViewAutoBudgetMonthly
  const fetchData = async () => {
    setLoading(true);

    const resYear = await GetYearBudget({
      ViewName: "vw_BG02_BudgetMonthly",
    });

    if (resYear.rows && resYear.rows.length > 0) {
      const dataJson = {
        BudgetYear: selectedYear.toString(),
      };

      const res = await GetViewAutoBudgetMonthly(dataJson);

      if (res.rows && res.rows.length > 0) {
        // data response
        setRawRow(res.rows);

        // year Option
        const years = Array.from(
          new Set(
            resYear.rows
              .map((r: any) => r.BudgetYear)
              .filter((y: any) => y !== null),
          ),
        ).sort();
        
        setYearOption(
          years.map((y: any) => ({
            label: y,
            value: y,
          })),
        );

         // divisions Option
        const divisions = Array.from(
          new Set(
            res.rows.map((r: any) => r.Division).filter((d: any) => d != null),
          ),
        );

        setDivisionOption(
          divisions.map((d: any) => ({
            label: d,
            value: d,
          })),
        );

      } else {
        setRawRow([]);
        setDivisionOption([]);
        setDepartmentOption([]);
        setFilterIncomeData(null);
        setFilterExpenseData(null);
        setIncomeTableKeys([]);
        setExpenseTableKeys([]);
      }
    } else {
      setRawRow([]);
      setYearOption([]);
      setDivisionOption([]);
      setDepartmentOption([]);
      setFilterIncomeData(null);
      setFilterExpenseData(null);
      setIncomeTableKeys([]);
      setExpenseTableKeys([]);
    }
    setLoading(false);
  };

  // onChange Year
  const handleYearChange = async (year: any) => {
    setSelectedYear(year);
    setSelectedMonths([]);
    setSelectedDivision([]);
    setSelectedDepartment([]);

    if (!year) return;

    try {
      setLoading(true);

      const dataJson = {
        BudgetYear: year.toString(),
      };

      const data = await GetViewAutoBudgetMonthly(dataJson);
      if (data?.rows?.length > 0) {
        setRawRow(data.rows);

        const divisions = Array.from(
          new Set(
            data.rows.map((r: any) => r.Division).filter((d: any) => d != null),
          ),
        );

        setDivisionOption(
          divisions.map((d: any) => ({
            label: d,
            value: d,
          })),
        );

        const departments = Array.from(
          new Set(
            data.rows
              .map((r: any) => r.Department)
              .filter((d: any) => d != null),
          ),
        );

        setDepartmentOption(
          departments.map((d: any) => ({
            label: d,
            value: d,
          })),
        );
      } else {
        setRawRow([]);
        setDivisionOption([]);
        setDepartmentOption([]);
      }

      setFilterIncomeData(null);
      setFilterExpenseData(null);
    } catch (error) {
      console.error("Error loading year data:", error);
    } finally {
      setLoading(false);
    }
  };
  
  // Sync Department ตาม Division
  useEffect(() => {
    if (!rawRow.length) return;

    // ถ้าไม่มี division แสดง department ทั้งหมด
    // ถ้าเลือก division ใหม่ ตัด department ที่ไม่เกี่ยวออก

    if (selectedDivision.length === 0) {
      const departments = Array.from(new Set(rawRow.map((r) => r.Department)));

      setDepartmentOption(departments.map((d) => ({ label: d, value: d })));

      return;
    }

    // filter department ตาม division
    const filteredDepartments = Array.from(
      new Set(
        rawRow
          .filter((r) => selectedDivision.includes(r.Division))
          .map((r) => r.Department),
      ),
    );

    setDepartmentOption(
      filteredDepartments.map((d) => ({
        label: d,
        value: d,
      })),
    );

    // ตัด department ที่ไม่ตรง division ออก
    setSelectedDepartment((prev) =>
      prev.filter((dept) => filteredDepartments.includes(dept)),
    );
  }, [selectedDivision, rawRow]);

  // master filter ทุก table
  const getFilteredRows = () => {
    let filtered = [...rawRow];

    if (selectedMonths.length > 0) {
      filtered = filtered.map((row) => {
        const newRow = { ...row };

        Object.keys(newRow).forEach((key) => {
          if (
            monthOption.some((m) => m.value === key) &&
            !selectedMonths.includes(key)
          ) {
            newRow[key] = 0;
          }
        });

        return newRow;
      });
    }

    if (selectedDivision.length > 0) {
      filtered = filtered.filter((r) => selectedDivision.includes(r.Division));
    }

    if (selectedDepartment.length > 0) {
      filtered = filtered.filter((r) =>
        selectedDepartment.includes(r.Department),
      );
    }

    return filtered;
  };

  useEffect(() => {
    const filtered = getFilteredRows();

    const income = transformRows(filtered, "income");
    const expense = transformRows(filtered, "expenses");

    setIncomeColumns(groupColumns(income));
    setExpenseColumns(groupColumns(expense));

    setIncomeData(income);
    setExpenseData(expense);

    // sync table filter ให้ถูกต้อง
    if (incomeTableKeys.length === 0) {
      setFilterIncomeData(null);
    } else {
      const synced = income.filter((row: any) =>
        incomeTableKeys.includes(row.key),
      );
      setFilterIncomeData(synced);
    }

    if (expenseTableKeys.length === 0) {
      setFilterExpenseData(null);
    } else {
      const synced = expense.filter((row: any) =>
        expenseTableKeys.includes(row.key),
      );
      setFilterExpenseData(synced);
    }

  }, [selectedDivision, selectedDepartment, selectedMonths, rawRow, incomeTableKeys, expenseTableKeys]);

  // set columns and group columns
  const groupColumns = (tableData: any[]) => {
    const monthOrder = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];

    const monthsToShow =
      selectedMonths.length > 0
        ? monthOrder.filter((m) => selectedMonths.includes(m))
        : monthOrder;

    return [
      {
        title: "รหัสบัญชี",
        dataIndex: "AccountCode",
        key: "AccountCode",
        width: 140,
        fixed: "left",
        filters: Array.from(
          new Set(tableData.map((item) => item.AccountCode)),
        ).map((code) => ({
          text: code,
          value: code,
        })),
        onFilter: (value: any, record: any) => record.AccountCode === value,
        filterSearch: true,
        filterMultiple: true,
      },
      {
        title: "ชื่อหมวดบัญชี",
        dataIndex: "AccountName",
        key: "AccountName",
        width: 260,
        fixed: "left",
        filters: Array.from(
          new Set(tableData.map((item) => item.AccountName)),
        ).map((name) => ({
          text: name,
          value: name,
        })),
        onFilter: (value: any, record: any) => record.AccountName === value,
        filterSearch: true,
        filterMultiple: true,
      },
      {
        title: "ส.อ.ท.",
        dataIndex: "TotalMonths",
        key: "TotalMonths",
        align: "right",
        fixed: "left",
        width: 180,
        render: (value: any) =>
          Number(value || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }),
      },
      ...monthsToShow.map((month) => ({
        title: month,
        dataIndex: month,
        key: month,
        width: 160,
        align: "right",
        render: (value: any) =>
          Number(value || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }),
      })),
    ];
  };

  // แปลง key rows table
  const transformRows = (rows: any[], type: string) => {
    const grouped: any = {};

    rows
      .filter((item) => item.TypeGroup === type)
      .forEach((item) => {
        // group แค่ รหัสบัญชี + ชื่อหมวดบัญชี
        const key = `${item.AccountCode}_${item.AccountName}`;

        if (!grouped[key]) {
          grouped[key] = {
            key,
            AccountCode: item.AccountCode,
            AccountName: item.AccountName,
            TotalMonths: 0,
            JAN: 0,
            FEB: 0,
            MAR: 0,
            APR: 0,
            MAY: 0,
            JUN: 0,
            JUL: 0,
            AUG: 0,
            SEP: 0,
            OCT: 0,
            NOV: 0,
            DEC: 0,
          };
        }

        // รวมค่าทุกเดือน
        grouped[key].JAN += Number(item.JAN || 0);
        grouped[key].FEB += Number(item.FEB || 0);
        grouped[key].MAR += Number(item.MAR || 0);
        grouped[key].APR += Number(item.APR || 0);
        grouped[key].MAY += Number(item.MAY || 0);
        grouped[key].JUN += Number(item.JUN || 0);
        grouped[key].JUL += Number(item.JUL || 0);
        grouped[key].AUG += Number(item.AUG || 0);
        grouped[key].SEP += Number(item.SEP || 0);
        grouped[key].OCT += Number(item.OCT || 0);
        grouped[key].NOV += Number(item.NOV || 0);
        grouped[key].DEC += Number(item.DEC || 0);
        grouped[key].TotalMonths += (selectedMonths.length > 0
          ? selectedMonths
          : ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"]
        ).reduce((sum, m) => sum + Number(item[m] || 0), 0);
      });

    return Object.values(grouped);
  };

  // get column summary low
  const getLeafColumns = (columns: any[]) => {
    const leaf: any[] = [];
    columns.forEach((col) => {
      if (!col.children) leaf.push(col);
      else col.children.forEach((child: any) => leaf.push(child));
    });
    return leaf;
  };

  // export ทุกตาราง
  const exportFullReport = () => {
    const wb = XLSX.utils.book_new();
    const wsData: any[][] = [];
    const headerRowIndexes: number[] = [];

    // ถ้ามี filter
    const exportIncome =
      filterIncomeData !== null ? [...filterIncomeData] : [...incomeData];

    const exportExpense =
      filterExpenseData !== null ? [...filterExpenseData] : [...expenseData];

    // header
    wsData.push(["รายงานงบประมาณของ ส.อ.ท. ประจำปีงบประมาณ " + selectedYear]);
    wsData.push([]);

    // build Section
    const buildSection = (
      title: string,
      columns: any[],
      data: any[],
      totalLabel: string,
    ) => {
      wsData.push([title]);
      wsData.push([]);

      const headerRow1: any[] = [];
      const headerRow2: any[] = [];
      const leafColumns: any[] = [];

      columns.forEach((col: any) => {
        if (!col.children) {
          headerRow1.push(col.title);
          headerRow2.push("");
          leafColumns.push(col);
        } else {
          const childCount = col.children.length;

          headerRow1.push(col.title);
          for (let i = 1; i < childCount; i++) {
            headerRow1.push("");
          }

          col.children.forEach((child: any) => {
            headerRow2.push(child.title);
            leafColumns.push(child);
          });
        }
      });

      const headerStartIndex = wsData.length;
      wsData.push(headerRow1);
      wsData.push(headerRow2);

      headerRowIndexes.push(headerStartIndex);
      headerRowIndexes.push(headerStartIndex + 1);

      // data
      data.forEach((row: any) => {
        wsData.push(leafColumns.map((col: any) => row[col.dataIndex] ?? 0));
      });

      // total
      const totalRow: any[] = [];

      leafColumns.forEach((col: any, index: number) => {
        if (index === 0) totalRow.push(totalLabel);
        else if (index === 1) totalRow.push("");
        else {
          const sum = data.reduce(
            (s: number, r: any) => s + (Number(r[col.dataIndex]) || 0),
            0,
          );
          totalRow.push(sum);
        }
      });

      wsData.push(totalRow);
      wsData.push([]);
      wsData.push([]);
    };

    // section
    buildSection("รายได้", incomeColumns, exportIncome, "รวมรายได้");
    buildSection("ค่าใช้จ่าย", expenseColumns, exportExpense, "รวมค่าใช้จ่าย");

    // สุทธิ
    const leafColumns: any[] = [];

    expenseColumns.forEach((col: any) => {
      if (!col.children) leafColumns.push(col);
      else col.children.forEach((child: any) => leafColumns.push(child));
    });

    const netRow: any[] = [];

    leafColumns.forEach((col: any, index: number) => {
      if (index === 0) netRow.push("สุทธิ");
      else if (index === 1) netRow.push("");
      else {
        const totalIncome = exportIncome.reduce(
          (s: number, r: any) => s + (Number(r[col.dataIndex]) || 0),
          0,
        );

        const totalExpense = exportExpense.reduce(
          (s: number, r: any) => s + (Number(r[col.dataIndex]) || 0),
          0,
        );

        netRow.push(totalIncome - totalExpense);
      }
    });

    wsData.push(netRow);
    wsData.push([]);
    wsData.push([]);

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // merges header
    const merges: any[] = [];
    const sectionColumnsList = [incomeColumns, expenseColumns];

    headerRowIndexes.forEach((rowIndex, idx) => {
      if (idx % 2 !== 0) return;

      const sectionIndex = Math.floor(idx / 2);
      const sectionColumns = sectionColumnsList[sectionIndex];

      let colIndex = 0;

      sectionColumns.forEach((col: any) => {
        if (!col.children) {
          colIndex++;
        } else {
          merges.push({
            s: { r: rowIndex, c: colIndex },
            e: {
              r: rowIndex,
              c: colIndex + col.children.length - 1,
            },
          });
          colIndex += col.children.length;
        }
      });
    });

    ws["!merges"] = merges;

    // style
    const range = XLSX.utils.decode_range(ws["!ref"] as string);
    const sectionTitles = ["รายได้", "ค่าใช้จ่าย", "สินทรัพย์ถาวร"];

    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellAddress]) continue;

        const value = ws[cellAddress].v;

        const isSectionTitle = sectionTitles.includes(value);
        const isMainTitle = R === 0 || R === 1;
        const isHeaderRow = headerRowIndexes.includes(R);

        const isNumber =
          typeof value === "number" ||
          (!isNaN(Number(value)) && value !== "" && value !== null);

        ws[cellAddress].s = {
          font: {
            bold: isSectionTitle || isMainTitle,
          },
          alignment: {
            vertical: "center",
            horizontal: isHeaderRow
              ? "center"
              : C === 0
                ? "left"
                : isNumber
                  ? "right"
                  : "left",
          },
          border:
            isSectionTitle || isMainTitle
              ? undefined
              : {
                  top: { style: "thin" },
                  bottom: { style: "thin" },
                  left: { style: "thin" },
                  right: { style: "thin" },
                },
        };

        if (isNumber && !isHeaderRow && C !== 0) {
          ws[cellAddress].t = "n";
          ws[cellAddress].z = "#,##0.00";
        }
      }
    }

    // auto width
    const colWidths: any[] = [];

    wsData[5].forEach((_: any, colIndex: number) => {
      if (colIndex === 0) {
        colWidths.push({ wch: 16 });
        return;
      }

      if (colIndex === 1) {
        colWidths.push({ wch: 28 });
        return;
      }

      let maxLength = 10;

      for (let i = 5; i < wsData.length; i++) {
        const cell = wsData[i][colIndex];
        if (cell !== undefined && cell !== null) {
          maxLength = Math.max(maxLength, cell.toString().length);
        }
      }

      colWidths.push({ wch: maxLength + 4 });
    });

    ws["!cols"] = colWidths;

    XLSX.utils.book_append_sheet(wb, ws, "รายงานงบประมาณ");

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    saveAs(
      new Blob([excelBuffer], {
        type: "application/octet-stream",
      }),
      `FTIBudgetByMonthFiscalYear_${selectedYear}.xlsx`,
    );
  };

  // export แยกแต่ละตาราง
  const exportSectionReport = (
    fileName: string,
    sheetName: string,
    title: string,
    columns: any[],
    data: any[],
    totalLabel: string,
  ) => {
    const wb = XLSX.utils.book_new();
    const wsData: any[][] = [];
    const headerRowIndexes: number[] = [];

    // data หลัง filter
    let exportData: any[] = [];

    if (sheetName === "รายได้") {
      exportData =
        filterIncomeData !== null ? [...filterIncomeData] : [...incomeData];
    } else if (sheetName === "ค่าใช้จ่าย") {
      exportData =
        filterExpenseData !== null ? [...filterExpenseData] : [...expenseData];
    }

    if (!exportData) exportData = [];

    // header
    wsData.push(["รายงานงบประมาณของ ส.อ.ท. ประจำปีงบประมาณ " + selectedYear]);
    wsData.push([]);
    wsData.push([title]);
    wsData.push([]);

    const headerRow1: any[] = [];
    const headerRow2: any[] = [];
    const leafColumns: any[] = [];

    columns.forEach((col: any) => {
      if (!col.children) {
        headerRow1.push(col.title);
        headerRow2.push("");
        leafColumns.push(col);
      } else {
        const childCount = col.children.length;

        headerRow1.push(col.title);
        for (let i = 1; i < childCount; i++) {
          headerRow1.push("");
        }

        col.children.forEach((child: any) => {
          headerRow2.push(child.title);
          leafColumns.push(child);
        });
      }
    });

    const headerStartIndex = wsData.length;
    wsData.push(headerRow1);
    wsData.push(headerRow2);

    headerRowIndexes.push(headerStartIndex);
    headerRowIndexes.push(headerStartIndex + 1);

    // data
    exportData.forEach((row: any) => {
      wsData.push(leafColumns.map((col: any) => row[col.dataIndex] ?? 0));
    });

    // total
    const totalRow: any[] = [];

    leafColumns.forEach((col: any, index: number) => {
      if (index === 0) {
        totalRow.push(totalLabel);
      } else if (index === 1) {
        totalRow.push("");
      } else {
        const sum = exportData.reduce(
          (s: number, r: any) => s + (Number(r[col.dataIndex]) || 0),
          0,
        );
        totalRow.push(sum);
      }
    });

    wsData.push(totalRow);

    // net
    if (sheetName === "ค่าใช้จ่าย") {
      const exportIncome =
        filterIncomeData !== null ? filterIncomeData : incomeData;

      const netRow: any[] = [];

      leafColumns.forEach((col: any, index: number) => {
        if (index === 0) {
          netRow.push("สุทธิ");
        } else if (index === 1) {
          netRow.push("");
        } else {
          const totalIncome = exportIncome.reduce(
            (s: number, r: any) => s + (Number(r[col.dataIndex]) || 0),
            0,
          );

          const totalExpense = exportData.reduce(
            (s: number, r: any) => s + (Number(r[col.dataIndex]) || 0),
            0,
          );

          netRow.push(totalIncome - totalExpense);
        }
      });

      wsData.push(netRow);
    }

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // merges header
    const merges: any[] = [];
    const sectionColumnsList = [incomeColumns, expenseColumns];

    headerRowIndexes.forEach((rowIndex, idx) => {
      if (idx % 2 !== 0) return;

      const sectionIndex = Math.floor(idx / 2);
      const sectionColumns = sectionColumnsList[sectionIndex];

      let colIndex = 0;

      sectionColumns.forEach((col: any) => {
        if (!col.children) {
          colIndex++;
        } else {
          merges.push({
            s: { r: rowIndex, c: colIndex },
            e: {
              r: rowIndex,
              c: colIndex + col.children.length - 1,
            },
          });
          colIndex += col.children.length;
        }
      });
    });

    ws["!merges"] = merges;

    // style
    const range = XLSX.utils.decode_range(ws["!ref"] as string);
    const sectionTitles = ["รายได้", "ค่าใช้จ่าย", "สินทรัพย์ถาวร"];

    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellAddress]) continue;

        const value = ws[cellAddress].v;

        const isSectionTitle = sectionTitles.includes(value);
        const isMainTitle = R === 0 || R === 1;
        const isHeaderRow = headerRowIndexes.includes(R);

        const isNumber =
          typeof value === "number" ||
          (!isNaN(Number(value)) && value !== "" && value !== null);

        ws[cellAddress].s = {
          font: {
            bold: isSectionTitle || isMainTitle,
          },
          alignment: {
            vertical: "center",
            horizontal: isHeaderRow
              ? "center"
              : C === 0
                ? "left"
                : isNumber
                  ? "right"
                  : "left",
          },
          border:
            isSectionTitle || isMainTitle
              ? undefined
              : {
                  top: { style: "thin" },
                  bottom: { style: "thin" },
                  left: { style: "thin" },
                  right: { style: "thin" },
                },
        };

        if (isNumber && !isHeaderRow && C !== 0) {
          ws[cellAddress].t = "n";
          ws[cellAddress].z = "#,##0.00";
        }
      }
    }

    // widths
    const colWidths: any[] = [];

    leafColumns.forEach((_, i) => {
      if (i === 0) {
        colWidths.push({ wch: 16 });
        return;
      }

      if (i === 1) {
        colWidths.push({ wch: 28 });
        return;
      }

      let maxLength = 10;

      wsData.forEach((row) => {
        const cell = row[i];
        if (cell !== undefined && cell !== null) {
          maxLength = Math.max(maxLength, cell.toString().length);
        }
      });

      colWidths.push({ wch: maxLength + 4 });
    });

    ws["!cols"] = colWidths;

    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    saveAs(
      new Blob([excelBuffer], {
        type: "application/octet-stream",
      }),
      fileName + ".xlsx",
    );
  };

  return (
    <div style={{ padding: 36 }}>
      {/* Header */}
      <Row
        justify="center"
        align="middle"
        style={{
          backgroundColor: "#282F6A",
          padding: "1rem",
          borderRadius: "8px",
        }}
      >
        <Col
          span={24}
          className="text-header-report"
          style={{ textAlign: "center" }}
        >
          รายงานงบประมาณของ ส.อ.ท. ตามรายเดือน
        </Col>
        <Col
          span={24}
          className="sub-text-header-report"
          style={{ textAlign: "center" }}
        >
          ประจำปีงบประมาณ {selectedYear}
        </Col>
      </Row>

      {/* Filters */}
      <Row
        gutter={[16, 16]}
        style={{
          marginTop: "2rem",
          padding: "1.5rem",
          backgroundColor: "#f0f2f5",
          borderRadius: "12px",
          border: "1px solid #d9d9d9",
        }}
      >
        {/* ปีงบประมาณ */}
        <Col xs={24} sm={24} md={8} lg={6} xl={2}>
          <div className="filter-label">ปีงบประมาณ (Year)</div>
          <Select
            options={yearOption}
            value={selectedYear}
            onChange={handleYearChange}
            style={{ width: "100%" }}
            size="large"
          />
        </Col>

        {/* Month */}
        <Col xs={24} sm={24} md={8} lg={8} xl={6}>
          <div className="filter-label">เดือน (Month)</div>
          <Select
            mode="multiple"
            options={monthOption}
            value={selectedMonths}
            onChange={(value) => setSelectedMonths(value)}
            allowClear
            size="large"
            style={{ width: "100%" }}
            placeholder="เลือกเดือน  (Month)"
          />
        </Col>

        <Col xs={24} sm={24} md={8} lg={8} xl={6}>
          <div className="filter-label">หน่วยงาน (Division)</div>
          <Select
            mode="multiple"
            options={divisionOption}
            value={selectedDivision}
            onChange={(value) => setSelectedDivision(value)}
            allowClear
            size="large"
            style={{ width: "100%" }}
            placeholder="เลือกหน่วยงาน (Division)"
          />
        </Col>

        <Col xs={24} sm={24} md={8} lg={8} xl={6}>
          <div className="filter-label">สายงาน (Department)</div>
          <Select
            mode="multiple"
            options={departmentOption}
            value={selectedDepartment}
            onChange={(value) => setSelectedDepartment(value)}
            allowClear
            style={{ width: "100%" }}
            placeholder="เลือกสายงาน (Department)"
            size="large"
          />
        </Col>

        {/* Export Full Report*/}
        <Col
          xs={24}
          sm={24}
          md={8}
          lg={10}
          xl={4}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button
            label="Export to Excel"
            icon="pi pi-file-excel"
            loading={loading}
            onClick={exportFullReport}
            className="button-export-excel-all"
          />
        </Col>
      </Row>

      {/* ตารางรายได้ */}
      <div>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginTop: "2rem" }}
        >
          <div className="text-body-report">รายได้</div>
          <Button
            label="Export to Excel"
            icon="pi pi-file-excel"
            loading={loading}
            onClick={() => {
              exportSectionReport(
                "FTIBudgetByMonthFiscalYear_รายได้_" + selectedYear,
                "รายได้",
                "รายได้",
                incomeColumns,
                incomeData,
                "รวมรายได้",
              );
            }}
            className="button-export-excel"
          />
        </Row>
        <Row style={{ marginTop: "1rem" }}>
          <Col span={24}>
            <Table
              className="budget-table"
              style={{ width: "100%" }}
              scroll={{ x: "max-content" }}
              columns={incomeColumns}
              dataSource={incomeData}
              loading={loading}
              rowKey="key"
              bordered={false}
              pagination={{ pageSize: pageSize }}
              size="small"
              summary={() => {
                const dataSource =
                  filterIncomeData !== null ? filterIncomeData : incomeData;

                if (!incomeColumns.length) return null;

                const leafColumns = getLeafColumns(incomeColumns);
                const totalRow: any = {};

                leafColumns.forEach((col: any) => {
                  if (
                    col.dataIndex !== "AccountCode" &&
                    col.dataIndex !== "AccountName"
                  ) {
                    totalRow[col.dataIndex] = dataSource.reduce(
                      (sum: number, row: any) =>
                        sum + (Number(row[col.dataIndex]) || 0),
                      0,
                    );
                  }
                });

                return (
                  <Table.Summary>
                    <Table.Summary.Row
                      className="footer-summary-row"
                      style={{ fontWeight: "bold" }}
                    >
                      <Table.Summary.Cell index={0}>
                        รวมรายได้
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={1} />

                      {leafColumns.slice(2).map((col: any, i: number) => (
                        <Table.Summary.Cell key={i} index={i + 2} align="right">
                          {totalRow[col.dataIndex]?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          }) ?? "0.00"}
                        </Table.Summary.Cell>
                      ))}
                    </Table.Summary.Row>
                  </Table.Summary>
                );
              }}
              onChange={(pagination, filters, sorter, extra) => {
                setFilterIncomeData(extra.currentDataSource);
                setIncomeTableKeys(extra.currentDataSource.map((r) => r.key));
              }}
            />
          </Col>
        </Row>
      </div>

      {/* ตารางค่าใช้จ่าย */}
      <div>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginTop: "2rem" }}
        >
          <div className="text-body-report">ค่าใช้จ่าย</div>
          <Button
            label="Export to Excel"
            icon="pi pi-file-excel"
            loading={loading}
            onClick={() =>
              exportSectionReport(
                "FTIBudgetByMonthFiscalYear_ค่าใช้จ่าย_" + selectedYear,
                "ค่าใช้จ่าย",
                "ค่าใช้จ่าย",
                expenseColumns,
                expenseData,
                "รวมค่าใช้จ่าย",
              )
            }
            className="button-export-excel"
          />
        </Row>
        <Row style={{ marginTop: "1rem" }}>
          <Col span={24}>
            <Table
              className="budget-table"
              columns={expenseColumns}
              dataSource={expenseData}
              rowKey="key"
              loading={loading}
              bordered={false}
              style={{ width: "100%" }}
              scroll={{ x: "max-content" }}
              pagination={{ pageSize: pageSize }}
              size="small"
              summary={() => {
                const dataSource =
                  filterExpenseData !== null ? filterExpenseData : expenseData;

                if (!expenseColumns.length) return null;

                const leafColumns = getLeafColumns(expenseColumns);

                const totalExpenseRow: any = {};
                const netRow: any = {};

                const incomeSource =
                  filterIncomeData !== null ? filterIncomeData : incomeData;

                leafColumns.forEach((col: any) => {
                  if (
                    col.dataIndex !== "AccountCode" &&
                    col.dataIndex !== "AccountName"
                  ) {
                    const totalExpense = dataSource.reduce(
                      (sum: number, row: any) =>
                        sum + (Number(row[col.dataIndex]) || 0),
                      0,
                    );

                    const totalIncome = incomeSource.reduce(
                      (sum: number, row: any) =>
                        sum + (Number(row[col.dataIndex]) || 0),
                      0,
                    );

                    totalExpenseRow[col.dataIndex] = totalExpense;
                    netRow[col.dataIndex] = totalIncome - totalExpense;
                  }
                });

                return (
                  <Table.Summary>
                    {/* รวมค่าใช้จ่าย */}
                    <Table.Summary.Row
                      className="footer-summary-row"
                      style={{ fontWeight: "bold" }}
                    >
                      <Table.Summary.Cell index={0}>
                        รวมค่าใช้จ่าย
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={1} />
                      {leafColumns.slice(2).map((col: any, i: number) => (
                        <Table.Summary.Cell key={i} index={i + 2} align="right">
                          {totalExpenseRow[col.dataIndex]?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                            },
                          ) ?? "0.00"}
                        </Table.Summary.Cell>
                      ))}
                    </Table.Summary.Row>

                    {/* สุทธิ */}
                    <Table.Summary.Row
                      className="net-summary-row"
                      style={{
                        fontWeight: "bold",
                        backgroundColor: "#282F6A",
                        color: "white",
                      }}
                    >
                      <Table.Summary.Cell index={0}>สุทธิ</Table.Summary.Cell>
                      <Table.Summary.Cell index={1} />
                      {leafColumns.slice(2).map((col: any, i: number) => (
                        <Table.Summary.Cell key={i} index={i + 2} align="right">
                          {netRow[col.dataIndex]?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          }) ?? "0.00"}
                        </Table.Summary.Cell>
                      ))}
                    </Table.Summary.Row>
                  </Table.Summary>
                );
              }}
              onChange={(pagination, filters, sorter, extra) => {
                setFilterExpenseData(extra.currentDataSource);
                setExpenseTableKeys(extra.currentDataSource.map((r) => r.key));
              }}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default BudgetByMonthFiscalYear;
